import { render, staticRenderFns } from "./OrderTipsCmp.vue?vue&type=template&id=38a98aa9&scoped=true"
import script from "./OrderTipsCmp.vue?vue&type=script&lang=js"
export * from "./OrderTipsCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a98aa9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a98aa9')) {
      api.createRecord('38a98aa9', component.options)
    } else {
      api.reload('38a98aa9', component.options)
    }
    module.hot.accept("./OrderTipsCmp.vue?vue&type=template&id=38a98aa9&scoped=true", function () {
      api.rerender('38a98aa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimList/cmp/OrderTipsCmp.vue"
export default component.exports